import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";
import {downloadFile} from "../../../services/downloadPdf";

// Ф2 (23.08.2026) — архивиране: двата файла на землището, в същия вид, в който
// се качват старите бази. Геодезистът си иска СВОЙ архив на въведеното.
//
// Щ7 (13.09.2026) — и цяла община наведнъж, като един ZIP.
//
// Съзнателно: файловете НЕ са резервно копие на приложението. Базата се
// архивира всяка нощ на сървъра; тези файлове са за него и за пренасяне между
// години. Надписът долу го казва и на екрана, за да не се разчита на тях за
// възстановяване след срив.
export const ArchiveSection = ({years}) => {
    const request = requester();
    const [year, setYear] = useState('');
    // Щ7: „едно землище" или „цяла община" — един и същ архив, различен обхват.
    const [scope, setScope] = useState('settlement');
    const [ekatte, setEkatte] = useState('');
    const [ekattes, setEkattes] = useState([]);
    const [municipality, setMunicipality] = useState('');
    const [municipalities, setMunicipalities] = useState([]);
    const [counts, setCounts] = useState(null);
    const [muniCounts, setMuniCounts] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setEkatte('');
        setMunicipality('');
        setCounts(null);
        setMuniCounts(null);
        if (!year) {
            setEkattes([]);
            setMunicipalities([]);
            return;
        }
        request.get(`${baseUrl()}/companies-initial-info/${year}/ids`)
            .then(setEkattes)
            .catch(() => setEkattes([]));
        // Общините идват от списъка със землища — предлагат се само тези, в
        // които за тази година изобщо има въведени данни.
        request.get(`${baseUrl()}/settlements`)
            .then(all => setMunicipalities(Array.isArray(all) ? all : []))
            .catch(() => setMunicipalities([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year]);

    // Общините с данни = общините на землищата с декларации за тази година.
    const общиниСДанни = (() => {
        const позволени = new Set(ekattes.map(e => e.settlement_ekatte));
        const имена = new Set();
        municipalities.forEach(s => {
            if (позволени.has(s.ekatte) && s.municipality) имена.add(s.municipality);
        });
        return [...имена].sort((a, b) => a.localeCompare(b, 'bg'));
    })();

    // Броячите се теглят при избор на землище — за да се вижда какво ще има във
    // файла, преди да се свали.
    useEffect(() => {
        setCounts(null);
        setError(null);
        if (scope !== 'settlement' || !year || !ekatte) return;
        request.get(`${baseUrl()}/archive/counts/${year}/${ekatte}`)
            .then(setCounts)
            .catch(err => setError((err && err.message) || 'Грешка при заявката.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, ekatte, scope]);

    useEffect(() => {
        setMuniCounts(null);
        setError(null);
        if (scope !== 'municipality' || !year || !municipality) return;
        request.get(`${baseUrl()}/archive/municipality-counts/${year}/${encodeURIComponent(municipality)}`)
            .then(setMuniCounts)
            .catch(err => setError((err && err.message) || 'Грешка при заявката.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, municipality, scope]);

    const свали = async (какво, име) => {
        setError(null);
        try {
            await downloadFile(`/archive/${какво}/${year}/${ekatte}`, име,
                'Свалянето не успя.');
        } catch (err) {
            setError((err && err.message) || 'Свалянето не успя.');
        }
    };

    const свалиОбщина = async () => {
        setError(null);
        setBusy(true);
        try {
            await downloadFile(
                `/archive/zip/${year}/${encodeURIComponent(municipality)}`,
                `Архив_${municipality}_${year}.zip`, 'Свалянето не успя.');
        } catch (err) {
            setError((err && err.message) || 'Свалянето не успя.');
        } finally {
            setBusy(false);
        }
    };

    const бележка = (
        <div className="mt-2" style={{fontSize: "13px", color: "var(--app-muted)"}}>
            Колоните са същите като при качването на стари бази, затова
            свален файл може да се качи обратно. В замените влизат
            всички, които засягат землището — и дадените, и получените;
            отказаните и чакащите одобрение не влизат.
            <br/>
            Тези файлове са ваш архив — те не заместват резервните копия
            на приложението, които се правят всяка нощ на сървъра.
        </div>
    );

    return (
        <div className="row g-3 align-items-center mt-1">
            <div className="col-auto">
                <label htmlFor="year-archive" className="col-form-label">Година:</label>
            </div>
            <div className="col-auto">
                <select id="year-archive" className="form-select" style={{width: "auto"}}
                        value={year} onChange={(e) => setYear(e.target.value)}>
                    <option value="">-- изберете --</option>
                    {years.map(y => <option key={y.id} value={y.year}>{y.year}</option>)}
                </select>
            </div>

            {year && (
                <>
                    {/* Щ7: изборът на обхват. Двата режима не се смесват —
                        иначе не се вижда кой от двата избора важи в момента. */}
                    <div className="col-auto">
                        <select className="form-select" style={{width: "auto"}}
                                value={scope} onChange={(e) => setScope(e.target.value)}>
                            <option value="settlement">Едно землище</option>
                            <option value="municipality">Цяла община</option>
                        </select>
                    </div>

                    {scope === 'settlement' && (
                        <>
                            <div className="col-auto">
                                <label htmlFor="settlements-archive" className="col-form-label">EKATTE:</label>
                            </div>
                            <div className="col-auto">
                                <input id="settlements-archive" className="form-control"
                                       style={{width: "180px"}} type="search"
                                       list="list-settlements-archive" autoComplete="on"
                                       value={ekatte}
                                       onChange={(e) => setEkatte(e.target.value)}/>
                                <datalist id="list-settlements-archive">
                                    {ekattes.map(d => <option key={d.id} value={d.settlement_ekatte}/>)}
                                </datalist>
                            </div>
                        </>
                    )}

                    {scope === 'municipality' && (
                        <>
                            <div className="col-auto">
                                <label htmlFor="municipality-archive" className="col-form-label">Община:</label>
                            </div>
                            <div className="col-auto">
                                <input id="municipality-archive" className="form-control"
                                       style={{width: "240px"}} type="search"
                                       list="list-municipalities-archive" autoComplete="on"
                                       placeholder="Изберете община..."
                                       value={municipality}
                                       onChange={(e) => setMunicipality(e.target.value)}/>
                                <datalist id="list-municipalities-archive">
                                    {общиниСДанни.map(m => <option key={m} value={m}/>)}
                                </datalist>
                            </div>
                        </>
                    )}
                </>
            )}

            {scope === 'settlement' && counts && (
                <div className="col-12">
                    <div className="mb-2" style={{color: "var(--app-muted)"}}>
                        {counts.settlement}, {year}: {counts.deals} замени ·{' '}
                        {counts.drawings} изчертани реда
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-outline-primary"
                                disabled={!counts.deals}
                                onClick={() => свали('deals',
                                    `Замени_${ekatte}_${year}.csv`)}>
                            Доброволни замени (CSV)
                        </button>
                        <button className="btn btn-outline-primary"
                                disabled={!counts.drawings}
                                onClick={() => свали('drawings',
                                    `Изчертани_${ekatte}_${year}.csv`)}>
                            Изчертани площи (CSV)
                        </button>
                    </div>
                    {бележка}
                </div>
            )}

            {scope === 'municipality' && muniCounts && (
                <div className="col-12">
                    {muniCounts.settlements.length === 0 ? (
                        <div className="alert alert-info mb-0">
                            В община {muniCounts.municipality} няма въведени данни за {year} година.
                        </div>
                    ) : (
                        <>
                            <div className="mb-2" style={{color: "var(--app-muted)"}}>
                                {muniCounts.municipality}, {year}:{' '}
                                {muniCounts.settlements.length} землища с данни ·{' '}
                                {muniCounts.deals} замени · {muniCounts.drawings} изчертани реда
                            </div>
                            <div className="mb-2" style={{fontSize: "13px", color: "var(--app-muted)"}}>
                                {muniCounts.settlements
                                    .map(s => `${s.name} (${s.deals}/${s.drawings})`)
                                    .join(' · ')}
                            </div>
                            <button className="btn btn-outline-primary" disabled={busy}
                                    onClick={свалиОбщина}>
                                {busy ? 'Сваляне...' : 'Свали архива на общината (ZIP)'}
                            </button>
                            <div className="mt-2" style={{fontSize: "13px", color: "var(--app-muted)"}}>
                                В архива има по една папка на землище с двата файла. Землище без
                                замени получава само файла с изчертаните и обратно — празни файлове
                                не влизат, за да личи къде наистина няма данни.
                            </div>
                            {бележка}
                        </>
                    )}
                </div>
            )}

            {error && <div className="col-12"><div className="alert alert-danger">{error}</div></div>}
        </div>
    );
};
